import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { ActivityIndicator, Animated, View } from 'react-native';

import { Screen } from '@/components/ScreenComponent';
import { ScreenNavBar } from '@/components/ScreenNavBar';
import { Box } from '@/components/lib/components';
import { NoActivityHistory } from '@/feature/transactions/components/NoActivityHistory';
import { common } from '@/styles/styles';

import { CasinoHistoryList } from '../components/CasinoHistoryList';
import { useCasinoHistory } from '../hooks/use-casino-history';

export const CasinoHistoryScreen = () => {
    const { t } = useTranslation('casino');
    const scrollAnim = useRef(new Animated.Value(0));

    const { data, isLoading, fetchNextPage, isFetchingNextPage } = useCasinoHistory();

    const transactions = data?.pages ?? [];

    const getViewContent = () => {
        if (transactions.length === 0) {
            return <NoActivityHistory title={t('no_history')} description={t('no_history_description')} />;
        }

        return (
            <CasinoHistoryList
                transactions={transactions}
                fetchNextPage={() => !isFetchingNextPage && fetchNextPage()}
                isFetchingNextPage={isFetchingNextPage}
                scrollAnim={scrollAnim}
            />
        );
    };

    return (
        <Screen>
            <ScreenNavBar title={'Casino history'} scrollAnim={scrollAnim} />
            {isLoading ? (
                <View testID="loadingIndicator" style={[common.flex, common.alignCenter, common.justifyCenter]}>
                    <ActivityIndicator />
                </View>
            ) : (
                <Box flex={1}>{getViewContent()}</Box>
            )}
        </Screen>
    );
};
